import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import { paystoneGiftCardOperation } from 'actions/EntityActions';
import { formInput } from 'actions/FormActions';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

class PaystoneGiftCardCancel extends Component {
    constructor(props, context) {
        super(props, context);
    }

    reverseTransaction = () => {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            CardNumber: p.cardNumber,
            PayStoneOperations: LOOKUP.PayStoneGiftCardOperationType.Cancel,
            WAN: p.cashflow.employee.id,
            WSN: p.cashflow.deviceId,
            TCR: p.tcr,
            InvoiceNumber: p.invoiceNumber,
            Amount: p.amount
        };
        this.props.paystoneGiftCardOperation(model);
    }
    
    render() {
        const { t } = this.props; 
        let p = this.props;
        return (
            <DialogInput
                title={<DialogHeaderWithClose text={t('pos.giftCard.cancel.label')} classicClass="posDialogClassic" handleClose={() => this.props.onCancel()} />}
                actions={[
                    <Button
                        key={1}
                        name="buttonRefundDialogCancel"
                        type="Button"
                        className="corner_X"
                        primary={false}
                        onTouchTap={() => this.props.onCancel()} />,
                    <Button
                        key={2}
                        className="pull-right space btnNewBrandPOS"
                        name="buttonRefundDialogConfirm"
                        label={t('common.confirm')}
                        primary={true}
                        onTouchTap={() => this.reverseTransaction()} />]}
                modal={true}
                style={{ zIndex: '980' }}
                open={this.props.show}
                autoScrollBodyContent={true}>
                <div>
                    <h4 className="purpleText">{t('pos.paystoneGiftcard.cancel.fillUpInfo')}</h4>
                    <div className="row">
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}CardNumber`}
                                fullWidth={true}
                                label={t('common.cardNum')}
                                floatingLabelText={t('common.cardNum')}
                                hintText={t('common.cardNum')} />
                        </div>
                        <div className="col-lg-12">
                            <DecimalInput name={`${p.name}Amount`}
                                fullWidth={true}
                                label={t('pos.paystoneGiftcard.cancel.activationReloadAmt')}
                                floatingLabelText={t('pos.paystoneGiftcard.cancel.activationReloadAmt')}
                                hintText={t('pos.paystoneGiftcard.cancel.activationReloadAmt')}/>
                        </div>
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}InvoiceNumber`}
                                fullWidth={true}
                                label={t('pos.paystoneGiftcard.cancel.invoiceNumber')}
                                floatingLabelText={t('pos.paystoneGiftcard.cancel.invoiceNumber')}
                                hintText={t('pos.paystoneGiftcard.cancel.invoiceNumber')} />
                        </div>
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}TCR`}
                                fullWidth={true}
                                label={t('pos.giftCard.tcrNumber.label')}
                                floatingLabelText={t('pos.giftCard.tcrNumber.label')}
                                hintText={t('pos.giftCard.tcrNumber.hintText')} />
                        </div>
                    </div>
                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        cardNumber: state.form[`PaystoneGiftCardCancelCardNumber`] || '',
        tcr: state.form[`PaystoneGiftCardCancelTCR`] || '',
        invoiceNumber: state.form[`PaystoneGiftCardCancelInvoiceNumber`] || '',
        amount: state.form[`PaystoneGiftCardCancelAmount`] || '',
        store: state.common.store,
        cashflow: state.entity.cashFlow
    };
}

function mapDispatchToProps(dispatch) {
    return {
        paystoneGiftCardOperation: (model) => dispatch(paystoneGiftCardOperation(model)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PaystoneGiftCardCancel));